import { validateNested } from "@shopify/react-form-state";

import { ListValidatorDictionary } from ".";

export function validateList<Input extends object, Fields, ParentFields>(
  validatorDictionary: ListValidatorDictionary<Fields, ParentFields>
) {
  // tslint:disable-next-line: no-any
  const validateItem = validateNested(validatorDictionary) as any;

  return (input: Input[], fields: Fields) => {
    const errors = input.map((item, index) => validateItem(item, fields, index));
    if (errors.some(error => error !== undefined)) {
      return errors;
    }
  };
}
